<template>
  <div>
    <dashboard-activity></dashboard-activity>
  </div>
</template>

<script>
import DashboardActivity from '@/components/admin/dashboard/MyActivity'

export default {
  components: {
    DashboardActivity
  },
  computed: {},
  methods: {}
}
</script>

<style></style>
